import React from "react";
import "./Intro.css";

const Hero = () => {
  return (
    <div id="projects-intro-container" className="row">
      <div className="mission col-xs-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3 p-5">
      <h1 id="brand">Our Clients</h1>
      <div className="mission">We provide our clients with high quality service and ultra fast turnaround times.</div>
      </div>
    </div>
  );
};

export default Hero;


// WEBPACK FOOTER //
// ./src/components/Works/Intro/Intro.js